import React from 'react';
import {
  BeatLoading, BounceLoading, CircularLoading,
  ClockLoading, RotateLoading, SpinLoading,
  WaveLoading, DashLoading, CopperLoading
} from 'respinner'


const LoadingSpinner = () => {
  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      {/* <div className="w-16 h-16 border-t-4 border-b-4 border-gray-900 rounded-full animate-spin"></div> */}
      <SpinLoading fill="#4C51BF" borderRadius={8} count={20} size={80} />
    </div>
  );
};

export default LoadingSpinner;
